import { useTranslations } from '@vocab/react';
import { ButtonLink, IconStatistics } from 'braid-design-system';
import { useEffect, useRef } from 'react';

import { SEARCH_PAGE_TRACKING_EVENTS } from 'src/App/services/tracking/trackingConfig';
import { useTracking } from 'src/App/services/tracking/useTracking';

import translations from './.vocab';
import { NudgeBanner } from './NudgeBanner';

const PROFILE_UPDATE_URL =
  '/profile/me?tracking=ILC-profileVisibility-profileSearchResults';

export const NudgeProfileUpdateBanner = () => {
  const { t } = useTranslations(translations);
  const trackingCallbacks = useTracking(SEARCH_PAGE_TRACKING_EVENTS);
  const hasTrackedDisplayRef = useRef(false);

  useEffect(() => {
    if (!hasTrackedDisplayRef.current) {
      trackingCallbacks.updateProfileBanner.trackComponentDisplayedEvent({
        component: {
          name: 'cta-update-your-profile',
          type: 'dialog',
        },
      });
      hasTrackedDisplayRef.current = true;
    }
  }, [trackingCallbacks]);

  return (
    <NudgeBanner
      title={t('YOUR_NEXT_JOB_COULD_BE_ONE_UPDATE_AWAY')}
      description={t('GIVING_PROFILE_QUICK_UPDATE_CAN_HELP')}
      actionButton={
        <ButtonLink
          onClick={() =>
            trackingCallbacks.updateProfileBanner.trackComponentPressedEvent({
              component: {
                name: 'update-your-profile',
                type: 'button',
              },
            })
          }
          href={PROFILE_UPDATE_URL}
          icon={<IconStatistics />}
          tone="brandAccent"
        >
          {t('UPDATE_PROFILE')}
        </ButtonLink>
      }
    />
  );
};
